export function buildQueryParams(filters: Record<string, any>): string {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([filterName, filterValue]) => {
    if (
      filterValue !== undefined &&
      filterValue !== null &&
      filterValue !== ''
    ) {
      params.append(filterName, String(filterValue));
    }
  });

  return params.toString();
}

export function getQueryParams(param: string): string {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) ?? '';
}